<div class="tab-guide">
  <div class="tab-guide__description">
    <h1 class="tab-guide__description--title">El Buscador Jurídico es la plataforma de recuperación de información
      institucional que sigue un Modelo de Administración del Conocimiento.
    </h1>
    <div class="tab-guide__description--separator components-bg--a2 my-4"></div>
    <p class="tab-guide__description--parag mb-3"> Da clic sobre un video para explorar el funcionamiento del Buscador
      Jurídico.</p>
  </div>
  <div class="container-fluid">
    <div class="card-header components-bg">
      <div class="row row-cols-1 row-cols-sm-2 row-cols-sm-2 row-cols-lg-3 row-cols-xl-3">
        <div class="col mb-4">         
          <div class="frame-tab">
            <iframe id="ensembleEmbeddedContent_QbiJORmApUiM8l-ornmHbA"
              src="https://scjn.ovp-vivaro.digital/embed/?v=657163ae88fcbccd9"
              title="Buscador Jurídico - Tutorial" frameborder="0" scrolling="no" class="frame-tab__video"
              allowfullscreen></iframe>
          </div>
          <div class="d-flex align-items-center mt-2">
            <em class="icons-vdos icon-libro skin-color-text"><span class="hidden">&nbsp;</span></em>
            <span class="skin-color-text">Suprema Corte de Justicia de la Nación</span>
          </div>
          <p class="ml-4">Inducción al Buscador Jurídico.</p>
        </div>
        <div class="col mb-4">
          <div class="frame-tab">
            <iframe id="ensembleEmbeddedContent_dK_8r4yx2EKcNZWmLmWkdQ"
              src="https://scjn.ovp-vivaro.digital/embed/?v=656763ae88fb0e0f3"
              title="Buscador Jurídico - Análisis de texto" frameborder="0" scrolling="no" class="frame-tab__video"
              allowfullscreen></iframe>
          </div>
          <div class="d-flex align-items-center mt-2">
            <em class="icons-vdos icon-libro skin-color-text"><span class="hidden">&nbsp;</span></em>
            <span class="skin-color-text">Suprema Corte de Justicia de la Nación</span>
          </div>
          <p class="ml-4">Realiza búsquedas por contexto a partir de consultas
            textuales o complementarias.</p>
        </div>
        <div class="col mb-4">
          <div class="frame-tab">
            <iframe id="ensembleEmbeddedContent_V_b4av5650KAXT4rSSQCLw"
              src="https://scjn.ovp-vivaro.digital/embed/?v=656963ae88fbdbcaa"
              title="Buscador Jurídico - Instancias" frameborder="0" scrolling="no" class="frame-tab__video"
              allowfullscreen></iframe>
          </div>
          <div class="d-flex align-items-center mt-2">
            <em class="icons-vdos icon-libro skin-color-text"><span class="hidden">&nbsp;</span></em>
            <span class="skin-color-text">Suprema Corte de Justicia de la Nación</span>
          </div>
          <p class="ml-4">Conoce las fuentes de información del Buscador Jurídico y los
            vínculos a buscadores especializados.
          </p>
        </div>
        <div class="col mb-4">
          <div class="frame-tab">
            <iframe id="ensembleEmbeddedContent_n8xhcpF3tU6ADNBU9PlePw"
              src="https://scjn.ovp-vivaro.digital/embed/?v=657063ae88fc50811"
              title="Buscador Jurídico - Precedentes" frameborder="0" scrolling="no" class="frame-tab__video"
              allowfullscreen></iframe>
          </div>
          <div class="d-flex align-items-center mt-2">
            <em class="icons-vdos icon-libro skin-color-text"><span class="hidden">&nbsp;</span></em>
            <span class="skin-color-text">Suprema Corte de Justicia de la Nación</span>
          </div>
          <p class="ml-4">Conoce los precedentes de una Controversia Constitucional y/o
            Acción de Inconstitucionalidad a partir de una Sentencia.</p>
        </div>
        <div class="col mb-4">
          <ng-container  *ngIf="false">
            <div class="frame-tab">
              <iframe id="ensembleEmbeddedContent_tXns0EtXr0Sko8oNSd23Ww"
                src="https://scjn.ovp-vivaro.digital/embed/?v=656863ae88fb6dfc3"
                title="Buscador Jurídico - Derechos Humanos" frameborder="0" scrolling="no" class="frame-tab__video"
                allowfullscreen></iframe>
            </div>
            <div class="d-flex align-items-center mt-2">
              <em class="icons-vdos icon-libro skin-color-text"><span class="hidden">&nbsp;</span></em>
              <span class="skin-color-text">Suprema Corte de Justicia de la Nación</span>
            </div>
            <p class="ml-4">Accede al buscador especializado de la Corte Interamericana
              de Derechos Humanos y del Sistema de Naciones Unidas.</p>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
